import component from './FilterItem';

export default component;
